module.exports = __webpack_public_path__ + "img/gift-box.901438dc.png";